import script from "./job_card.vue?vue&type=script&setup=true&lang=js"
export * from "./job_card.vue?vue&type=script&setup=true&lang=js"

import "./job_card.vue?vue&type=style&index=0&id=6197741d&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6197741d"]])

export default __exports__